import * as React from 'react';
import * as Theme from '@sail/theme-classic';
import {Action} from './Action.js';
import type {ActionProps} from './Action.js';

export type LinkProps = {
  /**
   * The type of the link
   * @external
   */
  type?: 'primary' | 'secondary';
} & ActionProps;
/**
 * @external
 * @param className
 * @param href
 * @param onPress
 * @param rel
 * @param tabIndex
 * @param target
 */
export const Link = Action.create<LinkProps>(
  function Link({type = 'primary', disabled = false, ...props}, View) {
    return (
      <View
        uses={[
          props,
          {disabled},
          Theme.LinkVariants.assign({type}),
          Theme.ActionVariants.assign({disabled}),
          Theme.Link,
        ]}
      />
    );
  },
  [
    Theme.IconVariants.internal_setAdaptiveDefaults({
      size: 'xsmall',
    }),
  ],
);
